// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__hArP-","rightAdornment":"Header_rightAdornment__sdWo7"};